<script lang="ts" setup>
withDefaults(
  defineProps<{
    icon: string
    title: string
    link?: string | null
  }>(),
  { link: null }
)
</script>

<template>
  <NuxtLink
    class="flex cursor-pointer flex-col items-center justify-center leading-6 !no-underline"
    :to="link ?? undefined"
  >
    <SvgIcon class="block !size-6" :name="icon" />

    <span class="text-sm text-black lg:text-base">
      {{ title }}
    </span>
  </NuxtLink>
</template>
